// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"Vg-z"};